import Image from 'next/image'

import Carousel from '../Common/slider'

const CUSTOMER_LIST = [
  {
    avatar: './images/customer_one.webp',
    comment:
      '“Nhân viên tư vấn rất nhanh chóng, hiệu quả. Mình đã đăng ký được gói vay của MBBank có chính sách rất sát với điều kiện của mình.”',
    name: 'Nguyễn Phương',
    title: 'Chủ cửa hàng phụ kiện, Hà Nội',
  },
  {
    avatar: './images/customer_two.webp',
    comment:
      '“Lần đầu đăng ký vay qua KiotViet, mình bất ngờ vì thủ tục đơn giản và nhanh. Nhân viên tư vấn và hỗ trợ nhẹ nhàng, không làm phiền như nhiều bên khác.”',
    name: 'Nguyễn Huệ',
    title: 'Chủ cửa hàng Mẹ và bé, Hà Nội',
  },
  {
    avatar: './images/customer_three.webp',
    comment:
      '“Phải dành lời khen cho KiotViet, kết nối được nhiều gói vay chính sách tốt. Xử lý vừa nhanh vừa hiệu quả. Bên ngân hàng cũng ưu tiên giải ngân hơn, không phải thủ tục phức tạp.”',
    name: 'Nguyễn Nam',
    title: 'Chủ quán cafe, Tp. HCM',
  },
]

const DetailCustomer = ({ avatar, comment, name, title }) => {
  return (
    <div className="flex md:flex-row flex-col md:p-12 px-4 py-8 gap-8 shadow-light-shadow bg-white lg:w-[585px] md:w-[704px] w-[311px] md:items-start items-center">
      <div
        id={`customer-${name}-${title}`}
        className="flex w-[108px] h-[108px]  relative"
      >
        <Image src={avatar} alt="customer-avatar" fill />
      </div>
      <div className="flex flex-col gap-4 self-stretch lg:w-[349px] md:w-[468px] w-[279px] md:text-start text-center">
        <div className="text-gray-scale-1-default text-base font-normal">
          {comment}
        </div>
        <div className="text-text-strong text-xl font-bold">{name}</div>
        <div className="text-text-secondary text-sm font-semibold">{title}</div>
      </div>
    </div>
  )
}

const CUSTOMERS = CUSTOMER_LIST.map((customer, index) => (
  <DetailCustomer
    key={index}
    avatar={customer.avatar}
    comment={customer.comment}
    name={customer.name}
    title={customer.title}
  />
))

export default function Customer() {
  return (
    <div className="lg:my-[94px] my-[60px] flex justify-center ">
      <div className="max-w-[1920px]">
        <div className="flex flex-col items-center">
          <div
            id="customer-title"
            className="text-navy text-center text-[30px] leading-9 font-bold max-md:px-4"
          >
            Khách hàng nói về chúng tôi
          </div>
          <div className="flex lg:w-[1264px] md:w-[768px] w-[375px]">
            <Carousel slides={CUSTOMERS} />
          </div>
        </div>
      </div>
    </div>
  )
}
